// Reglas del capturador que dependen del club. Para agregar un club a una
// regla, sumar su Id en la lista correspondiente.

const ACS = "9f0da71f-5e39-42a1-a953-e9607a290911"; // ACS Vacation
const SGW = "7944e7bf-02e0-42af-8da6-0d0858c32f39"; // Sunward Getaways
const TBX = "f7c39e28-9d05-413d-a96d-969fff808229"; // Travel Box

const normaliza = (id) => String(id || "").toLowerCase();

// Ven en el perfil del socio las pestañas de Reservaciones y Acciones (envío de
// token y restablecer contraseña) y la fecha del último inicio de sesión.
export const CLUBES_RESERVAS_ACCIONES = [ACS, SGW];

export function tieneReservasYAcciones(clubId) {
  return CLUBES_RESERVAS_ACCIONES.includes(normaliza(clubId));
}

// Al elegir el tipo de membresía en el alta, VIP, Smart y Last Minute quedan
// en Unlimited (99).
export const CLUBES_SEMANAS_UNLIMITED = [SGW];

export function semanasUnlimitedAutomaticas(clubId) {
  return CLUBES_SEMANAS_UNLIMITED.includes(normaliza(clubId));
}

export const SEMANAS_UNLIMITED = 99;

// Años guardados para una membresía vitalicia (el deslizador muestra "Lifetime"
// arriba de 80 y al guardar se convierte en 99).
export const ANIOS_VITALICIO = 99;

// Tipos de membresía (CatTipoVenta) visibles para un club:
// - los que tienen `Clubes` son exclusivos de esos clubes;
// - si el club tiene tipos exclusivos, ve solo esos;
// - si no, ve los generales (sin `Clubes`), como Exit y Regular.
export function tiposMembresiaDelClub(tipos, clubId) {
  const lista = Array.isArray(tipos) ? tipos : [];
  const id = normaliza(clubId);
  const propios = lista.filter(
    (t) => Array.isArray(t.Clubes) && t.Clubes.map(normaliza).includes(id)
  );
  if (propios.length) return propios;
  return lista.filter((t) => !Array.isArray(t.Clubes) || !t.Clubes.length);
}

// Botón "Upgrade" en el contrato (aparte de "Edit contract"): permite cambiar
// el precio y al guardar agrega el sufijo -UP al número de contrato.
export const CLUBES_UPGRADE_CON_PRECIO = [TBX];

export function upgradeConPrecio(clubId) {
  return CLUBES_UPGRADE_CON_PRECIO.includes(normaliza(clubId));
}

// 12345 → 12345-UP → 12345-UP2 → 12345-UP3 …
export function siguienteNumeroUpgrade(numero) {
  const actual = String(numero || "").trim();
  const m = actual.match(/^(.*)-UP(\d*)$/i);
  if (!m) return `${actual}-UP`;
  const siguiente = m[2] ? Number(m[2]) + 1 : 2;
  return `${m[1]}-UP${siguiente}`;
}
